export const SMALL_WIDTH = 640

export const NAVIGATION_ITEMS = [
    { id: 'analyze', label: 'Analyze', path: '', matchPath: '/', exact: true },
    { id: 'myresumes', label: 'My Resumes', path: 'myresumes', matchPath: '/myresumes', exact: false },
    { id: 'craft', label: 'Craft', path: 'craft', matchPath: '/craft', exact: true },
    // { id: 'landing', label: 'Landing', path: 'landing', matchPath: '/landing' },
    // { id: 'bragsheet', label: 'Brag Sheet', path: 'bragSheet', matchPath: '/bragsheet' }
]